export const API="https://netmedsdata.onrender.com"

// export const Product_API="http://34.93.199.25:8080/products"
// export const Product_API="https://udyog2-dftm.onrender.com/products"  LIVE

// export const Product_API="https://34.93.199.25/products"


export const Cart_API="https://netmedsdata.onrender.com/cart"
export const Home_API="https://netmedsdata.onrender.com/home"
export const User_API="https://netmedsdata.onrender.com/user"
export const SaveForLater_API="https://netmedsdata.onrender.com/saveForlater"
export const Premium_API="https://netmedsdata.onrender.com/premiumMember"


// const base = "http://10.5.71.153:3001";
// const base = "http://localhost:3001";

//const base = "https://udyog-backend.onrender.com"

const base = "https://udyog-v-1-ap-00c0.onrender.com";

export const Product_API= base + "/products"
export const Register_DB= base + "/register"
export const SignIn_DB= base + "/signin"
export const Submit_DB= base + "/seller"
export const SubmitBuyer_DB = base + "/buyer"
export const CALCULATE = base + "/calculate"
export const ORDER_API = base + "/orders"
export const GETCUSTDET = base + "/customers"

// https://netmedsdata.onrender.com
// https://udyog-backend.onrender.com
// https://udyogbackend.b-cdn.net/
// https://udyog.onrender.com 
// http://35.200.207.254:3001/
// http://34.93.199.25:8080/
// https://backendserver.b-cdn.net/
// htt

